import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import Arrow from '@mui/icons-material/KeyboardArrowDown';

function CustomAutocomplete(props) {
    const {
        options = [],
        label,
        error,
        multiple = false,
        changeTextField,
        onSelect,
        loading = false,
        sx = {},
        groupBy,
        noOptionsText = 'No options',
        helperText = null,
        fullWidth = false,
        freeSolo = false,
        disableCloseOnSelect = false,
        readOnly = false,
        onOpen = () => {},
        style = {},
        ...custom
    } = props;

    const [open, setOpen] = useState(false);
    const asyncLoading = open && loading;

    return (
        <Controller
            {...custom}
            render={({ field: { onChange, value, ...field }, fieldState: { error } }) => {
                const controlledValue = value ?? (multiple ? [] : null);

                return (
                    <div style={{ position: 'relative', ...style }}>
                        <Autocomplete
                            sx={{
                                border: `1px solid ${error ? '#f00' : 'transparent'}`,
                                background: 'white',
                                borderRadius: '10px',
                                minHeight: { xs: '46px', xl: '50px' },
                                '.MuiChip-label': { maxWidth: '100px' },
                                '.MuiOutlinedInput-root': { padding: '3px' },
                                ...sx,
                            }}
                            open={open}
                            options={options}
                            groupBy={groupBy}
                            multiple={multiple}
                            freeSolo={freeSolo}
                            readOnly={readOnly}
                            fullWidth={fullWidth}
                            loading={asyncLoading}
                            noOptionsText={noOptionsText}
                            filterSelectedOptions
                            popupIcon={<Arrow />}
                            onOpen={(e) => {
                                setOpen(true);
                                onOpen(e);
                            }}
                            onClose={() => setOpen(false)}
                            getOptionLabel={(option) => option.name ?? ''}
                            disableCloseOnSelect={disableCloseOnSelect}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            value={controlledValue} // Always controlled
                            onChange={(e, data) => {
                                onChange(data);
                                if (onSelect) onSelect(data);
                            }}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={label}
                                    error={!!error}
                                    helperText={helperText}
                                    onChange={(e) => {
                                        params.inputProps.onChange(e);
                                        if (changeTextField) changeTextField(e.target.value);
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {asyncLoading && <CircularProgress color="inherit" size={20} />}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            {...custom}
                            {...field}
                        />
                        {error?.message && <div className="label error-message">{error.message}</div>}
                    </div>
                );
            }}
        />
    );
}

export default CustomAutocomplete;
